<template>
  <div class="page home pt-16 text--secondary">
    <v-container>
      <v-row class="text-center mt-10">
        <v-col>
          <h1 class="text-h1 mb-3 mt-8">Istat <span class="font-weight-medium">TMS</span>Helper</h1>
        </v-col>
      </v-row>

      <div class="text-center mt-5">
        <h4 class="mt-3 mb-5 text-h4 font-weight-light" style="line-height: 3rem">
          Tool di supporto per la compilazione guidata <br />
          del questionario della rilevazione statistica <br />
          “Trasporto Merci su Strada”
        </h4>
      </div>
    </v-container>
  </div>
</template>

<script>
// Component
export default {
  name: 'HomePage',
  components: {},
}
</script>
